<div class="container-fluid" style="margin-top: -40px">
  <div class="dashboard">
    <!-- Period filter card -->
    <div class="mb-4">
      <div class="card h-100">
        <div class="card-body d-flex align-items-center flex-wrap">
          <div class="row align-items-center overview-filter-bar flex-grow-1">
            <div class="col-auto d-flex align-items-center gap-2">
              <label class="form-label mb-0 overview-filter-label"
                >Period</label
              >
              <p-dropdown
                [options]="datePresetOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="datePreset"
                (onChange)="onPresetChange()"
                placeholder="Select period"
                styleClass="overview-period-dropdown"
              />
            </div>
            <div class="col-auto d-flex align-items-center gap-2">
              <label class="mb-0 overview-filter-label">Start</label>
              <input
                type="date"
                class="form-control form-control-sm"
                [ngModel]="
                  filterStartDate ? (filterStartDate | date : 'yyyy-MM-dd') : ''
                "
                (ngModelChange)="onStartDateChange($event)"
              />
            </div>
            <div class="col-auto d-flex align-items-center gap-2">
              <label class="mb-0 overview-filter-label">End</label>
              <input
                type="date"
                class="form-control form-control-sm"
                [ngModel]="
                  filterEndDate ? (filterEndDate | date : 'yyyy-MM-dd') : ''
                "
                (ngModelChange)="onEndDateChange($event)"
              />
            </div>
          </div>
          <button
            class="side-menu-button2 ms-auto"
            (click)="refresh()"
            type="button"
          >
            <i class="pi pi-refresh me-1"></i>Refresh
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <h2 class="client-name">Overview</h2>
        <div class="flags-container">
          <div class="flags" style="width: 500px">
            <apx-chart
              [series]="targetsStatusChartOptions.series ?? []"
              [chart]="targetsStatusChartOptions.chart ?? { type: 'bar' }"
              [xaxis]="targetsStatusChartOptions.xaxis ?? {}"
              [yaxis]="targetsStatusChartOptions.yaxis ?? {}"
              [dataLabels]="targetsStatusChartOptions.dataLabels ?? {}"
              [grid]="targetsStatusChartOptions.grid ?? {}"
              [stroke]="targetsStatusChartOptions.stroke ?? {}"
              [title]="targetsStatusChartOptions.title ?? {}"
              [colors]="targetsStatusChartOptions.colors ?? []"
              [tooltip]="targetsStatusChartOptions.tooltip ?? {}"
              [plotOptions]="targetsStatusChartOptions.plotOptions ?? {}"
              [fill]="targetsStatusChartOptions.fill ?? {}"
              [states]="targetsStatusChartOptions.states ?? {}"
              [legend]="targetsStatusChartOptions.legend ?? {}"
            ></apx-chart>
          </div>
          <!-- <div class="flags">
              <div class="flag flex-column gap-2" [ngClass]="{'flag-all-trials': true}">
                <div>Total Targets</div>
                <div class="overview-flag-value">{{ statistics.totalTargets }}</div>
              </div>
              <div class="flag flex-column gap-2">
                <div>Targets Mastered</div>
                <div class="overview-flag-value">{{ statistics.masterTargets }}</div>
              </div>
              <div class="flag flex-column gap-2">
                <div>Targets In Maintenance</div>
                <div class="overview-flag-value">{{ statistics.maintenanceTargets }}</div>
              </div>
              <div class="flag flex-column gap-2">
                <div>% Mastered</div>
                <div class="overview-flag-value">{{ statistics.percentageMastered }}%</div>
              </div>
            </div> -->
        </div>
      </div>
    </div>

    <!-- Two-column layout -->
    <div class="row">
      <!-- Left Column -->
      <div class="col-12 col-md-6">
        <!--Targets status chart-->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">Programs Status</h5>
            </div>
            <div
              class="card-body p-0"
              style="max-height: 250px; overflow: auto"
            >
              <div id="programsStatusChart">
                <apx-chart
                  [series]="programsStatusChartOptions.series ?? []"
                  [chart]="programsStatusChartOptions.chart ?? { type: 'bar' }"
                  [xaxis]="programsStatusChartOptions.xaxis ?? {}"
                  [yaxis]="programsStatusChartOptions.yaxis ?? {}"
                  [dataLabels]="programsStatusChartOptions.dataLabels ?? {}"
                  [grid]="programsStatusChartOptions.grid ?? {}"
                  [stroke]="programsStatusChartOptions.stroke ?? {}"
                  [title]="programsStatusChartOptions.title ?? {}"
                  [colors]="programsStatusChartOptions.colors ?? []"
                  [tooltip]="programsStatusChartOptions.tooltip ?? {}"
                  [plotOptions]="programsStatusChartOptions.plotOptions ?? {}"
                  [fill]="programsStatusChartOptions.fill ?? {}"
                  [states]="programsStatusChartOptions.states ?? {}"
                  [legend]="programsStatusChartOptions.legend ?? {}"
                ></apx-chart>
              </div>
            </div>
          </div>
        </div>

        <!-- Average Trial Counts -->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">
                Average Trial Counts per day ({{ loadedPeriodLabel }})
              </h5>
            </div>
            <div class="card-body p-0">
              <p-table
                [value]="averageTrialCounts"
                styleClass="p-datatable-sm"
                [tableStyle]="{ 'min-width': '50rem' }"
                [scrollable]="true"
                scrollHeight="250px"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Target</th>
                    <th class="text-center">Average Trials</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-trial>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0)"
                        (click)="openTarget(trial)"
                        >{{ trial.Name }}</a
                      >
                    </td>
                    <td class="text-center">{{ trial.Count }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <!-- Highest Performing Targets -->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">Highest Performing Targets</h5>
            </div>
            <div class="card-body p-0">
              <p-table
                [value]="highestPerformingTargets"
                styleClass="p-datatable-sm"
                [tableStyle]="{ 'min-width': '50rem' }"
                [scrollable]="true"
                scrollHeight="250px"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Target</th>
                    <th>Date Opened</th>
                    <th>Trial Count</th>
                    <th>Percentage</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-target>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0)"
                        (click)="openTarget(target)"
                        >{{ target.Name }}</a
                      >
                    </td>
                    <td>{{ target.DateOpened | date }}</td>
                    <td>{{ target.TrialCount }}</td>
                    <td>
                      <div class="progress" style="height: 15px">
                        <div
                          class="progress-bar bg-success"
                          role="progressbar"
                          [style.width]="target.Percentage + '%'"
                          [attr.aria-valuenow]="target.Percentage"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {{ target.Percentage }}%
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <!-- Lowest Performing Targets -->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">Lowest Performing Targets</h5>
            </div>
            <div class="card-body p-0">
              <p-table
                [value]="lowestPerformingTargets"
                styleClass="p-datatable-sm"
                [tableStyle]="{ 'min-width': '50rem' }"
                [scrollable]="true"
                scrollHeight="250px"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Target</th>
                    <th>Date Opened</th>
                    <th>Trial Count</th>
                    <th>Percentage</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-target>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0)"
                        (click)="openTarget(target)"
                        >{{ target.Name }}</a
                      >
                    </td>
                    <td>{{ target.DateOpened | date }}</td>
                    <td>{{ target.TrialCount }}</td>
                    <td>
                      <div class="progress" style="height: 15px">
                        <div
                          class="progress-bar bg-danger"
                          role="progressbar"
                          [style.width]="target.Percentage + '%'"
                          [attr.aria-valuenow]="target.Percentage"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {{ target.Percentage }}%
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <!-- Trial Counts Today -->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">Trial Counts Today</h5>
            </div>
            <div class="card-body p-0">
              <p-table
                [value]="trialCountsToday"
                styleClass="p-datatable-sm"
                [tableStyle]="{ 'min-width': '50rem' }"
                [scrollable]="true"
                scrollHeight="250px"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Task/Skill</th>
                    <th class="text-center">Count</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-trial>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0)"
                        (click)="openTarget(trial)"
                        >{{ trial.Name }}</a
                      >
                    </td>
                    <td class="text-center">{{ trial.Count }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <!-- Recently Mastered Targets -->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">
                Recently Mastered Targets ({{ loadedPeriodLabel }})
              </h5>
            </div>
            <div class="card-body p-0">
              <p-table
                [value]="recentlyMasteredTargets"
                styleClass="p-datatable-sm"
                [tableStyle]="{ 'min-width': '50rem' }"
                [scrollable]="true"
                scrollHeight="250px"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Target Name</th>
                    <th>Date Opened</th>
                    <th>Date Mastered</th>
                    <th>Trials to Mastery</th>
                    <th>Teaching Days to Mastery</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-target>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0)"
                        (click)="openTarget(target)"
                        >{{ target.Name }}</a
                      >
                    </td>
                    <td>{{ target.DateOpened | date }}</td>
                    <td>{{ target.DateMastered | date }}</td>
                    <td>{{ target.TrialsToMastery }}</td>
                    <td>{{ target.TeachingDaysToMastery }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <!-- Student Statistics -->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">Student Statistics ({{ loadedPeriodLabel }})</h5>
            </div>
            <div class="card-body">
              <table class="table">
                <tbody>
                  <tr>
                    <td><strong>Avg Trials to Mastery:</strong></td>
                    <td>{{ statistics.AvgTrialsToMastery }}</td>
                  </tr>
                  <tr>
                    <td><strong>Avg Teaching Days to Mastery:</strong></td>
                    <td>{{ statistics.AvgTeachingDaysToMastery }}</td>
                  </tr>
                  <tr>
                    <td><strong>Open Targets:</strong></td>
                    <td>{{ statistics.OpenTargets }}</td>
                  </tr>
                  <tr>
                    <td><strong>% of Targets Mastered:</strong></td>
                    <td>{{ statistics.PercentageMastered }}%</td>
                  </tr>
                  <tr>
                    <td><strong>% of Targets Trending Up:</strong></td>
                    <td>{{ statistics.PercentageTrendingUp }}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column -->
      <div class="col-12 col-md-6">
        <!-- Current Targets in Baseline -->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">Current Targets in Baseline</h5>
            </div>
            <div class="card-body p-0">
              <p-table
                [value]="currentTargetsInBaseline"
                styleClass="p-datatable-sm"
                [tableStyle]="{ 'min-width': '50rem' }"
                [scrollable]="true"
                scrollHeight="250px"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Skill Area</th>
                    <th>Program</th>
                    <th>Targets</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-target>
                  <tr>
                    <td>{{ target.SkillArea }}</td>
                    <td>{{ target.Program }}</td>
                    <td>
                      <a
                        href="javascript:void(0)"
                        (click)="openTarget({ Id: target.TargetID })"
                        >{{ target.Target }}</a
                      >
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <!-- Targets Mastered Last 3 Months -->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">Targets Mastered ({{ loadedPeriodLabel }})</h5>
            </div>
            <div class="card-body">
              <div id="targetsChartThreeMonths">
                <apx-chart
                  [series]="targetsMasteredChartOptions.series ?? []"
                  [chart]="
                    targetsMasteredChartOptions.chart ?? { type: 'line' }
                  "
                  [xaxis]="targetsMasteredChartOptions.xaxis ?? {}"
                  [yaxis]="targetsMasteredChartOptions.yaxis ?? {}"
                  [dataLabels]="targetsMasteredChartOptions.dataLabels ?? {}"
                  [grid]="targetsMasteredChartOptions.grid ?? {}"
                  [stroke]="targetsMasteredChartOptions.stroke ?? {}"
                  [title]="targetsMasteredChartOptions.title ?? {}"
                  [colors]="targetsMasteredChartOptions.colors ?? []"
                ></apx-chart>
              </div>
            </div>
          </div>
        </div>

        <!-- Targets Trending Up -->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">
                Targets Trending Up ({{ loadedPeriodLabel }})
              </h5>
            </div>
            <div class="card-body p-0">
              <p-table
                [value]="targetsTrendingUp"
                styleClass="p-datatable-sm"
                [tableStyle]="{ 'min-width': '50rem' }"
                [scrollable]="true"
                scrollHeight="250px"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Target</th>
                    <th>Date Opened</th>
                    <th>Trial Count</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-target>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0)"
                        (click)="openTarget(target)"
                        >{{ target.Name }}</a
                      >
                    </td>
                    <td>{{ target.DateOpened | date }}</td>
                    <td>{{ target.TrialCount }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <!-- Targets Trending Down -->
        <div class="mb-4">
          <div class="card h-100">
            <div class="card-header overview-table-header">
              <h5 class="mb-0">
                Targets Trending Down ({{ loadedPeriodLabel }})
              </h5>
            </div>
            <div class="card-body p-0">
              <p-table
                [value]="targetsTrendingFlat"
                styleClass="p-datatable-sm"
                [tableStyle]="{ 'min-width': '50rem' }"
                [scrollable]="true"
                scrollHeight="250px"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Target</th>
                    <th>Date Opened</th>
                    <th>Trial Count</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-target>
                  <tr>
                    <td>
                      <a
                        href="javascript:void(0)"
                        (click)="openTarget(target)"
                        >{{ target.Name }}</a
                      >
                    </td>
                    <td>{{ target.DateOpened | date }}</td>
                    <td>{{ target.TrialCount }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if(targetToOpen){
<div class="supervisor-dialog-backdrop" (click)="targetToOpen = null"></div>
<dialog
  class="supervisor-dialog bg-white"
  style="z-index: 1000; max-width: 80rem"
  open
>
  <app-target
    [patientID]="targetToOpen.PatientID?.toString() ?? ''"
    [target]="targetToOpen"
    [isSelecting]="false"
    [selectAll]="false"
    [id]="targetToOpen.ID"
    [isExpanded]="true"
    [isIncludeDeletedFilterSelected]="false"
    [isIncludeArchivedFilterSelected]="false"
    [isIncludeMasteredFilterSelected]="false"
  />
</dialog>
} @if(isLoading){
<app-loading-indicator></app-loading-indicator>
}
